import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from "@angular/core";

@Directive({
    selector: "[appPassiveTouch]"
})
export class PassiveTouchDirective implements AfterViewInit, OnDestroy {
    @Input() touchStart: (event: TouchEvent) => void;
    @Input() touchMove: (event: TouchEvent) => void;
    @Input() touchEnd: (event: TouchEvent) => void;

    private boundStart: (e: Event) => void;
    private boundMove: (e: Event) => void;
    private boundEnd: (e: Event) => void;

    constructor(private el: ElementRef<HTMLElement>) { }

    ngAfterViewInit(): void {
        this.boundStart = (e: Event) => {
            if (this.touchStart) this.touchStart(e as TouchEvent);
        };
        this.boundMove = (e: Event) => {
            if (this.touchMove) this.touchMove(e as TouchEvent);
        };
        this.boundEnd = (e: Event) => {
            if (this.touchEnd) this.touchEnd(e as TouchEvent);
        };

        // Attach passive listeners to avoid scroll-blocking warnings
        this.el.nativeElement.addEventListener("touchstart", this.boundStart, { passive: true });
        this.el.nativeElement.addEventListener("touchmove", this.boundMove, { passive: true });
        this.el.nativeElement.addEventListener("touchend", this.boundEnd, { passive: true });
    }

    ngOnDestroy(): void {
        this.el.nativeElement.removeEventListener("touchstart", this.boundStart as EventListener);
        this.el.nativeElement.removeEventListener("touchmove", this.boundMove as EventListener);
        this.el.nativeElement.removeEventListener("touchend", this.boundEnd as EventListener);
    }
}


